import { Flex } from 'components'
import { createContext, useContext, useEffect, useState } from 'react'
import { useDefaultBackground } from '../../utils/traitUtils'
import Layout from '../Layout'
import { SView } from '../scaled'
import { useExplorerConfig } from './ExplorerConfigProvider'
import { SessionContext } from './SessionContextProvider'

export interface IShortcutContext {
  showShortcut: boolean
  toggleShortcut: () => void
}

export const ShortcutContext = createContext<IShortcutContext>({} as any)

export function ShortcutProvider({ children }: { children: React.ReactNode }) {
  const { templateDocs } = useExplorerConfig()
  const { status } = useContext(SessionContext)
  const defaultBackground = useDefaultBackground()

  const [showShortcut, setShowShortcut] = useState(false)

  useEffect(() => {
    if (showShortcut && (status === 'init' || status === 'screensaver')) setShowShortcut(false)
  }, [status])

  const layoutShortcut = templateDocs?.template.layoutShortcut
  const toggleShortcut = () => setShowShortcut(s => !s)

  return (
    <ShortcutContext.Provider value={{ showShortcut, toggleShortcut }}>
      <Flex flex={1}>
        {children}

        {showShortcut && (
          <Flex
            zIndex={1}
            position="absolute"
            inset={0}
            align="center"
            justify="center"
            backgroundImage={defaultBackground}
            backgroundSize="cover"
          >
            <SView gap={15}>
              <Layout keyPath={`${layoutShortcut?.key}`} style={{ height: 700, width: 1000 }} />
            </SView>
          </Flex>
        )}
      </Flex>
    </ShortcutContext.Provider>
  )
}
